/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Photo
 */
export interface Photo {
    /**
     * 
     * @type {string}
     * @memberof Photo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Photo
     */
    baseUrl: string;
}

/**
 * Check if a given object implements the Photo interface.
 */
export function instanceOfPhoto(value: object): value is Photo {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('baseUrl' in value) || value['baseUrl'] === undefined) return false;
    return true;
}

export function PhotoFromJSON(json: any): Photo {
    return PhotoFromJSONTyped(json, false);
}

export function PhotoFromJSONTyped(json: any, ignoreDiscriminator: boolean): Photo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'baseUrl': json['baseUrl'],
    };
}

export function PhotoToJSON(value?: Photo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'baseUrl': value['baseUrl'],
    };
}

